import { createContext } from "react";

const portalContext = createContext();

export default portalContext;
